import { Entity, Field } from "typegraph";

import TagSet from "./TagSet";

@Entity({one: "bundleTag", many: "tagListBundleTagsUser"})
export default class BundleTag {

	@Field()
	public id: string;

	@Field()
	public name: string;

	@Field({entity: TagSet})
	public tagSet: TagSet;

	@Field()
	public sortIndex: number;

}



// WEBPACK FOOTER //
// ./src/panels/refineTag/entities/BundleTag.ts